import { phoneCodes } from '../config/constants';

export const phoneCodePrepender = (e) => {
  const phoneCode = phoneCodes[process.env.REACT_APP_APP_TYPE];
  if (!e.target.value || e.target.value.length < phoneCode.length) {
    e.target.value = phoneCode;
  }
};
